import React, { useEffect } from 'react';
import { ArrowLeft } from 'lucide-react';

const NotFoundPage = () => {
  useEffect(() => {
    const previousTitle = document.title;
    const robots = document.querySelector('meta[name="robots"]');
    const previousRobots = robots?.getAttribute('content');

    document.title = 'Page Not Found | EFAM Fitness';
    robots?.setAttribute('content', 'noindex,follow');

    return () => {
      document.title = previousTitle;
      if (robots && previousRobots) robots.setAttribute('content', previousRobots);
    };
  }, []);

  return (
    <main className="min-h-screen bg-black text-white flex items-center justify-center px-6">
      <div className="max-w-xl text-center glass-card rounded-2xl p-10 border border-cyan-500/30">
        <p className="text-cyan-400 font-bold tracking-[0.25em] mb-4">404</p>
        <h1 className="text-4xl font-bold mb-4">That page is not part of the EFAM range.</h1>
        <p className="text-gray-400 mb-8">
          The address may have changed. Return to the worldwide EMS and red-light equipment store.
        </p>
        <a
          href="/"
          className="inline-flex items-center justify-center bg-cyan-500 hover:bg-cyan-400 text-black font-bold rounded-full px-8 py-4 transition-colors"
        >
          <ArrowLeft className="mr-2" size={18} />
          Back to EFAM Fitness
        </a>
      </div>
    </main>
  );
};

export default NotFoundPage;
